<template>
  <div class="md-card md-card-signup">
    <slot name="title"></slot>

    <div class="md-card-content">
      <div class="md-layout">
        <slot name="content-left"></slot>
        <slot name="content-right"></slot>
      </div>
    </div>

    <div class="md-card-actions">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "signup-card",
};
</script>

<style lang="css"></style>
